import axios from 'axios'
import * as utils from './api-utils'

export default {
  login(data) {
    return axios.post(utils.getApiUrl('/login'), data)
  },
  logout() {
    return axios.delete(utils.getApiUrl('/logout'))
  },
  getMe() {
    return axios.get(utils.getApiUrl('/users/me'))
  },
}
